import { useState, useEffect } from 'react';
import api from '../api/clients';
import { useAuthStore } from '../store/authStore';

interface Category {
  id: number;
  nombre: string;
  descripcion: string | null;
  created_at: string;
}

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const { token } = useAuthStore.getState();
        
        if (!token) {
          setLoading(false);
          return;
        }

        const response = await api.get('/categories');
        
        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          setError(response.data.error || 'Error al cargar categorías');
        }
      } catch (err: any) {
        setError(err.message || 'Error al cargar categorías');
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  return { categories, loading, error };
}